import { VueDatePicker } from "@vuepic/vue-datepicker";

export default VueDatePicker;
